import moment from "moment-timezone";
import { Grid, Segment } from "semantic-ui-react";

import { INTERVIEW_REQUEST_OUTSTANDING_STATES } from "common/helpers/interviewRequest";
import CandidateAvatar from "../../../Managers/Hiring/components/Candidate/Avatar";
import SegmentHeader from "./SegmentHeader";

// Consider as outstanding when candidate requests for more availability
const RequestsOutstanding = ({ interviewRequests }) => {
  const outstandingRequests = _.filter(interviewRequests, (request) =>
    INTERVIEW_REQUEST_OUTSTANDING_STATES.find((state) => state == request.step)
  );

  return (
    <Segment.Group>
      <SegmentHeader
        icon="refresh"
        title="Requests awaiting confirmation"
        labelCount={outstandingRequests.length}
      />
      {outstandingRequests.map((request) => {
        const interviewDurationHours = request.duration / 60 / 60;

        return (
          <Segment key={request.id}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3}>
                  <CandidateAvatar
                    profile_picture_url={
                      request.membership.unified_app.user.profile_picture_url
                    }
                    size={65}
                  />
                </Grid.Column>
                <Grid.Column width={13}>
                  <h2>{request.membership.unified_app.user.full_name}</h2>
                  <p>
                    Sent{" "}
                    {moment
                      .unix(request.created_at)
                      .tz(moment.tz.guess())
                      .format("M/D/YY [at] hh:mm a z")}
                    <br />
                    {`${interviewDurationHours} hour ${request.interview_type} interview`}
                  </p>
                  <p className="is-gray">
                    Interviewing for {request.membership.job.name}
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        );
      })}
    </Segment.Group>
  );
};

export default RequestsOutstanding;
